'use strict';

exports.decode = exports.parse = require('./decode');
exports.encode = exports.stringify = require('./encode');



//////////////////
// WEBPACK FOOTER
// ./node_modules/.0.2.1@querystring-es3/index.js
// module id = 1094
// module chunks = 1